module.exports = {
      id: "live-usage",
      viewBox: "0 0 20 20",
      url: __webpack_public_path__ + "svg-sprite-c71831da97eff2ec188167649c252867.svg#live",
      toString: function () {
        return this.url;
      }
    }